var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouponIconCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.843 1.11612C20.3312 1.60427 20.3312 2.39573 19.843 2.88388L8.74766 13.9793C8.25951 14.4674 7.46805 14.4674 6.9799 13.9793L1.11612 8.11548C0.627961 7.62733 0.627961 6.83587 1.11612 6.34772C1.60427 5.85956 2.39573 5.85956 2.88388 6.34772L7.86378 11.3276L18.0753 1.11612C18.5634 0.627961 19.3549 0.627961 19.843 1.11612Z"
  })));
}
export default SvgCouponIconCheck;